//Getters
export const ZIPCODE = 'shared/ZIPCODE';
export const RENTALCONTAINERSLIST = 'shared/RENTALCONTAINERSLIST'
export const DOORDIRECTION = 'shared/DOORDIRECTION'
export const DELIVERYSPACE = 'shared/DELIVERYSPACE'
export const CONTAINERCONDITION = 'shared/CONTAINERCONDITION'
export const TWOMONTHS = 'shared/TWOMONTHS'
export const DELIVERYINSTRUCTIONS = 'shared/DELIVERYINSTRUCTIONS'
export const DELIVERYCONTACTNAME = 'shared/DELIVERYCONTACTNAME'
export const DELIVERYCONTACTPHONE = 'shared/DELIVERYCONTACTPHONE'
export const CARTLINEITEM = 'shared/CARTLINEITEM'
export const FIRSTACCEPTABLEDATE = 'shared/FIRSTACCEPTABLEDATE'
export const UNACCEPTABLEDATES = 'shared/UNACCEPTABLEDATES'
export const TERMSNCONDITIONS = 'shared/TERMSNCONDITIONS'
export const PREDELIVERYANSWERS = 'shared/PREDELIVERYANSWERS'
export const MOVECONTAINERS = 'shared/MOVECONTAINERS'
export const RENTALSDURATION = 'shared/RENTALSDURATION'
export const DELIVERYSURFACETYPE = 'shared/DELIVERYSURFACETYPE'
export const SOFTSURFACEACKNOWLEDGE = 'shared/SOFTSURFACEACKNOWLEDGE'
export const COUNTRY_CODE = 'shared/COUNTRY_CODE'

//Mutations
export const MUTATE_UPDATE_ZIPCODE = 'shared/MUTATE_UPDATE_ZIPCODE';
export const MUTATE_UPDATE_RENTALCONTAINERSLIST = 'shared/MUTATE_UPDATE_RENTALCONTAINERSLIST';
export const MUTATE_UPDATE_DOORDIRECTION = 'shared/MUTATE_UPDATE_DOORDIRECTION'
export const MUTATE_UPDATE_DELIVERYSPACE = 'shared/MUTATE_UPDATE_DELIVERYSPACE'
export const MUTATE_UPDATE_CONTAINERCONDITION = 'shared/MUTATE_UPDATE_CONTAINERCONDITION'
export const MUTATE_UPDATE_TWOMONTHS = 'shared/MUTATE_UPDATE_TWOMONTHS'
export const MUTATE_UPDATE_DELIVERYINSTRUCTIONS = 'shared/MUTATE_UPDATE_DELIVERYINSTRUCTIONS'
export const MUTATE_UPDATE_DELIVERYCONTACTNAME = 'shared/MUTATE_UPDATE_DELIVERYCONTACTNAME'
export const MUTATE_UPDATE_DELIVERYCONTACTPHONE = 'shared/MUTATE_UPDATE_DELIVERYCONTACTPHONE'
export const MUTATE_UPDATE_CARTLINEITEM = 'shared/MUTATE_UPDATE_CARTLINEITEM'
export const MUTATE_UPDATE_EMPTYCART = 'shared/MUTATE_UPDATE_EMPTYCART'
export const MUTATE_UPDATE_UNACCEPTABLEDATES = 'shared/MUTATE_UPDATE_UNACCEPTABLEDATES'
export const MUTATAE_UPDATE_TERMSNCONDITIONS = 'shared/MUTATAE_UPDATE_TERMSNCONDITIONS'
export const MUTATE_UPDATE_PREDELIVERYANSWERS = 'shared/MUTATE_UPDATE_PREDELIVERYANSWERS'
export const MUTATE_UPDATE_PREDELIVERYANSWERSDEFAULT = 'shared/MUTATE_UPDATE_PREDELIVERYANSWERSDEFAULT'
export const MUTATE_UPDATE_MOVECONTAINERS = 'shared/MUTATE_UPDATE_MOVECONTAINERS'
export const MUTATE_UPDATE_RENTALSDURATION = 'shared/MUTATE_UPDATE_RENTALSDURATION'
export const MUTATE_UPDATE_DELIVERYSURFACETYPE = 'shared/MUTATE_UPDATE_DELIVERYSURFACETYPE'
export const MUTATE_UPDATE_SOFTSURFACEACKNOWLEDGE = 'shared/MUTATE_UPDATE_SOFTSURFACEACKNOWLEDGE'
export const MUTATE_UPDATE_COUNTRY_CODE = 'shared/MUTATE_UPDATE_COUNTRY_CODE'

//Actions
export const ACTIONS_UPDATE_ZIPCODE = 'shared/ACTIONS_UPDATE_ZIPCODE';
export const ACTIONS_UPDATE_RENTALCONTAINERSLIST = 'shared/ACTIONS_UPDATE_RENTALCONTAINERSLIST';
export const ACTIONS_UPDATE_DOORDIRECTION = 'shared/ACTIONS_UPDATE_DOORDIRECTION'
export const ACTIONS_UPDATE_DELIVERYSPACE = 'shared/ACTIONS_UPDATE_DELIVERYSPACE'
export const ACTIONS_UPDATE_CONTAINERCONDITION = 'shared/ACTIONS_UPDATE_CONTAINERCONDITION'
export const ACTIONS_UPDATE_TWOMONTHS = 'shared/ACTIONS_UPDATE_TWOMONTHS'
export const ACTIONS_UPDATE_DELIVERYINSTRUCTIONS = 'shared/ACTIONS_UPDATE_DELIVERYINSTRUCTIONS'
export const ACTIONS_UPDATE_DELIVERYCONTACTNAME = 'shared/ACTIONS_UPDATE_DELIVERYCONTACTNAME'
export const ACTIONS_UPDATE_DELIVERYCONTACTPHONE = 'shared/ACTIONS_UPDATE_DELIVERYCONTACTPHONE'
export const ACTIONS_UPDATE_CARTLINEITEM = 'shared/ACTIONS_UPDATE_CARTLINEITEM'
export const ACTIONS_UPDATE_EMPTYCART = 'shared/ACTIONS_UPDATE_EMPTYCART'
export const ACTIONS_UPDATE_UNACCEPTABLEDATES = 'shared/ACTIONS_UPDATE_UNACCEPTABLEDATES'
export const ACTIONS_UPDATE_TERMSNCONDITIONS = 'shared/ACTIONS_UPDATE_TERMSNCONDITIONS'
export const ACTIONS_UPDATE_PREDELIVERYANSWERS = 'shared/ACTIONS_UPDATE_PREDELIVERYANSWERS'
export const ACTIONS_UPDATE_PREDELIVERYANSWERSDEFAULT = 'shared/ACTIONS_UPDATE_PREDELIVERYANSWERSDEFAULT'
export const ACTIONS_UPDATE_MOVECONTAINERS = 'shared/ACTIONS_UPDATE_MOVECONTAINERS'
export const ACTIONS_UPDATE_RENTALSDURATION = 'shared/ACTIONS_UPDATE_RENTALSDURATION'
export const ACTIONS_UPDATE_DELIVERYSURFACETYPE = 'shared/ACTIONS_UPDATE_DELIVERYSURFACETYPE'
export const ACTIONS_UPDATE_SOFTSURFACEACKNOWLEDGE = 'SHARED/ACTIONS_UPDATE_SOFTSURFACEACKNOWLEDGE'
export const ACTIONS_UPDATE_COUNTRY_CODE = 'shared/ACTIONS_UPDATE_COUNTRY_CODE'
